import { useState } from 'react'
import { api, type KlaerungAnsicht } from '../api'
import { uhrzeit } from '../tagebuch'

export function Klaerungen({ klaerungen, onGeklaert }: { klaerungen: KlaerungAnsicht[]; onGeklaert: () => void }) {
  return (
    <section className="klaerungen">
      <h2>{klaerungen.length === 1 ? 'Eine Rückfrage' : `${klaerungen.length} Rückfragen`}</h2>
      {klaerungen.map((k) => (
        <Klaerung key={k.klaerung.id} ansicht={k} onGeklaert={onGeklaert} />
      ))}
    </section>
  )
}

function Klaerung({ ansicht, onGeklaert }: { ansicht: KlaerungAnsicht; onGeklaert: () => void }) {
  const { klaerung: k, kandidaten } = ansicht
  const [transkript, setTranskript] = useState(false)
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)

  const aktion = async (f: () => Promise<unknown>) => {
    setLaeuft(true)
    setFehler(null)
    try {
      await f()
      onGeklaert()
    } catch (e) {
      setFehler((e as Error).message)
      setLaeuft(false)
    }
  }

  const datum = new Date(k.aufgenommenAm).toLocaleDateString('de-DE', { timeZone: k.zeitzone, weekday: 'short', day: 'numeric', month: 'numeric' })

  return (
    <article className="karte klaerung">
      <p>
        Wer ist <strong>„{k.person.name}“</strong>
        {k.person.beschreibung && <span className="leise"> ({k.person.beschreibung})</span>}?
      </p>
      <p className="leise klein">
        Notiz vom {datum}, {uhrzeit(k)}
        {k.transkript && (
          <>
            {' · '}
            <button className="link" onClick={() => setTranskript(!transkript)}>
              {transkript ? 'Notiz ausblenden' : 'Notiz zeigen'}
            </button>
          </>
        )}
      </p>
      {transkript && <blockquote>{k.transkript}</blockquote>}
      {k.person.fakten.length > 0 && (
        <ul className="fakten klein">
          {k.person.fakten.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>
      )}
      {k.person.begruendung && <p className="leise klein">Einschätzung der KI: {k.person.begruendung}</p>}
      {fehler && <p className="fehler">{fehler}</p>}
      <div className="auswahl">
        {kandidaten.map((p) => (
          <button key={p.id} disabled={laeuft} onClick={() => aktion(() => api.klaerungZuordnen(k.id, p.id))}>
            {p.name}
            {p.beschreibung && <small>{p.beschreibung}</small>}
          </button>
        ))}
        <button className="zweitrangig" disabled={laeuft} onClick={() => aktion(() => api.klaerungNeu(k.id))}>
          Jemand Neues
        </button>
        <button className="link" disabled={laeuft} onClick={() => aktion(() => api.klaerungIgnorieren(k.id))}>
          Nicht merken
        </button>
      </div>
    </article>
  )
}
